import * as d3 from 'd3';
import { Component, ElementRef, Input, OnChanges,OnDestroy, OnInit  } from '@angular/core';
import {
  select,
  scaleBand,
  axisBottom,
  scaleLinear,
  axisLeft,
  scaleOrdinal,
  stack,
} from 'd3';

@Component({
  selector: 'app-stacked-chart',
  templateUrl: './stacked-chart.component.html',
  styleUrls: ['./stacked-chart.component.scss']
})
export class StackedChartComponent implements OnInit, OnChanges,OnDestroy  {
  @Input() chartData: any[] = [];
  @Input() showLoader: boolean = false;
  @Input() keys: string[] = [];  // The keys for the stacked data

  public svgWidth: number = 650;
  public svgHeight: number = 340;
  public tableHeaders: string[] = [];

  ngOnInit () {
    select('#bar').selectAll('svg').remove();
    this.svgWidth = 650;
    this.svgHeight = 340;
    this.initializeChart()    
  }
  ngOnChanges () {
    select('#bar').selectAll('svg').remove();
    this.svgWidth = 650;
    this.svgHeight = 340;
    this.initializeChart()    
  }

  initializeChart()
  {
    this.tableHeaders = this.chartData.map(row => row.name);;
    // Clear the previous content of the SVG
    select('#bar').selectAll('svg').remove();

    // set the dimensions and margins of the graph
    const margin = { top: 10, right: 30, bottom: 0, left: 50 },
      width = (this.svgWidth - 100) - margin.left - margin.right,
      height = (this.svgHeight - 100) - margin.top - margin.bottom;

    // Select the existing SVG element
    const svg = select('#bar')
      .attr('width', (this.svgWidth - 100))
      .attr('height', (this.svgHeight - 100))
      .attr('viewBox', `0 0 ${this.svgWidth} ${this.svgHeight}`)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    // List of groups = names (x-axis values)
    const groups = this.chartData.map((d) => d.name);

    // Add X axis
    const x = scaleBand()
      .domain(groups)
      .range([0, width])
      .padding(0.6);

    svg
      .append('g')
      .attr('transform', `translate(0, ${height})`)
      .call(axisBottom(x).tickSizeOuter(0));

    // Calculate the maximum value to determine the Y scale domain
    const maxValue = d3.max(this.chartData, (d) => 
      d3.sum(this.keys, (key) => d[key] || 0)
    );

    // Add Y axis
    const y = scaleLinear().domain([0, maxValue!]).range([height, 0]);
    svg.append('g').call(axisLeft(y));

    // Define a color palette
    const color = scaleOrdinal()
      .domain(this.keys)
      .range(['#FFFFFF','#FFE600']);  // Customize your colors here

    // Stack the data for each key
    const stackedData = stack()
      .keys(this.keys)
      .value((d, key) => d[key])(this.chartData);

    // Show the bars
    svg
      .append('g')
      .selectAll('g')
      .data(stackedData)
      .join('g')
      .attr('fill', (d: any) => color(d.key as string) as string)
      .selectAll('rect')
      .data((d) => d)
      .join('rect')
      .attr('x', (d) => {
        const xValue = x(d.data['name'] as any);
        return xValue !== undefined ? xValue : 0; 
      })
      .attr('y', (d) => y(d[1]))
      .attr('height', (d) => y(d[0]) - y(d[1]))
      .attr('width', x.bandwidth());
  }

  ngOnDestroy() {
    select('#bar').selectAll('svg').remove();
  }
  
}
